import React, { Component } from "react"
import { API } from "../../API"

export default class NavigateToShareProfile extends Component {
  componentDidMount = async () => {
    const id = window.location.search.substring(1).split("id=")[1]
    let inst;
    let campuses;
    let personnel;

    try {
      await API.getInstitutionDataById(id)
        .then((res) => {
          inst = res.data;
          // console.log(inst);
        })

      await API.getMultipleCampusById(inst.campuses)
        .then((res) => {
          campuses = res.data;
          // console.log(campuses)
        })

      await API.getPersonnelByInstId(inst._id)
        .then((res) => {
          personnel = res.data;
          // console.log(personnel)
        })

      const path = {
        pathname: "/CollegeSharedProfile",
        state: {
          inst: inst,
          campuses: campuses,
          personnel: personnel
        },
      }
      this.props.history.push(path)
    }
    catch (err) {
      console.log(err.response)
    }
  }

  render = () => <div />
}
